<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> 分配数据权限
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div class="container">
            <el-form :inline="true" label-width="120px">
                <el-form-item label="用户名称:">
                    <span>{{realName}}</span>
                </el-form-item>
            </el-form>

        </div>
        <div class="container">

            <tree-transfer
                    :button_text="['添加','取消']"
                    :title="transferTitle"
                    :from_data="leftData"
                    :to_data="rightData"
                    :defaultProps="defaultProps"
                    @add-btn="add"
                    @remove-btn="remove"
                    filter
                    height="400px"
                    :mode="mode"
                    :node_key="nodeKey"
                    :pid="parentId"
                    v-if="refreshTree"
                    ref="treeTransfer"
                    :default-checked-keys="defaultCheckedKeys"
            ></tree-transfer>
        </div>
    </div>
</template>

<script>
    import Api from '../../api/authority/index'
    import TreeTransfer from 'el-tree-transfer'
    export default {
        name: "assignDataAuth",
        components: {
            TreeTransfer
        },
        props: {
            node_key:{
                type:String,
                default:'authId'
            },
            pid:{
                type:String,
                default:'parentAuthId'
            }
        },
        data() {
            return {
                rightData:[],
                leftData:[],
                realName: this.$route.params.realName,
                transferTitle:['商品分类权限',   '已选数据权限'],
                parentId:'parentId',
                nodeKey:'categoryId',
                mode:'transfer',
                defaultProps:{
                    label: 'categoryName',
                    children: 'children',
                },
                categoryIdList:[],
                refreshTree:true,
                defaultCheckedKeys:[]
            }
        },
        computed: {},
        created() {
            this.checkDataAuth()
            this.getDataAuth()
        },
        methods: {
            async getDataAuth(){
                let params = {

                }
                this.leftData.length = 0
                let res = await  Api.queryAllCategory(params)

                        if(res.code == '200'){
                            let obj = {}
                            this.$set(obj,'parentId',0)
                            this.$set(obj,'categoryName','平台分类')
                            this.$set(obj,'categoryId',1)
                            this.$set(obj,'children',[])
                            obj.children = res.data
                            this.leftData.push(obj)
                            this.formatLeftData(this.leftData)
                        }
            },
            async checkDataAuth(){
                let params = {
                    memberId: this.$route.params.memberId
                }
                this.rightData.length = 0
                let res = await Api.queryUserDataAuthTree(params)

                if(res.data){
                    this.rightData.push(res.data)
                    this.getDefaultCheckKeys(this.rightData)
                }else {
                    this.defaultCheckedKeys.length = 0
                }

            },
            add(fromData, toData){
                let tree = toData
                this.categoryIdList = []
                this.formAuthIdList(tree)
                let params = {
                    memberId: this.$route.params.memberId,
                    list: this.categoryIdList
                }
                Api.insertDataAuth(params)
                    .then((res) => {
                        if(res.code == '200'){
                            this.$message({
                                type:'success',
                                message:'新增权限成功'
                            })
                            this.leftData.length = 0
                            setTimeout(() => {
                                //查询树的数据
                                this.checkDataAuth()
                                this.getDataAuth();
                                //<el-tree>组件使用v-if重新加载
                                this.refreshTree = false
                                this.$refs.treeTransfer.$nextTick(() => {
                                    this.refreshTree = true;
                                })
                            }, 100);
                        }
                    })
            },
            remove(fromData, toData){
                this.categoryIdList = []
                console.log(toData)
                this.formAuthIdList(toData)
                let params = {
                    memberId: this.$route.params.memberId,
                    list: this.categoryIdList
                }
                Api.insertDataAuth(params)
                    .then((res) => {
                        if(res.code == '200'){
                            this.$message({
                                type:'success',
                                message:'删除权限成功'
                            })
                        }
                        this.leftData.length = 0
                        this.defaultCheckedKeys.length = 0
                        setTimeout(() => {
                            //查询树的数据
                            this.checkDataAuth()
                            this.getDataAuth()
                            //<el-tree>组件使用v-if重新加载
                            this.refreshTree = false
                            this.$refs.treeTransfer.$nextTick(() => {
                                this.refreshTree = true;
                            })
                        }, 500);
                    })
            },
            formAuthIdList(arr){
                for(let i in arr){
                    let obj = {}
                    this.$set(obj,'parentObjectId', arr[i].parentId)
                    this.$set(obj,'objectId', arr[i].categoryId)
                    this.$set(obj,'name', arr[i].categoryName)
                    this.categoryIdList.push(obj)
                    if(arr[i].children){
                        this.formAuthIdList(arr[i].children);
                    }
                }
            },
            getDefaultCheckKeys(data){
                if(data.length){
                    for(let i=0;i<data.length;i++){
                        this.defaultCheckedKeys.push(data[i].categoryId)
                        if(data[i].children && data[i].children.length){
                            this.getDefaultCheckKeys(data[i].children)
                        }
                    }
                }
            },
            formatLeftData(data){
                if(data.length){
                    for(let i=0;i<data.length;i++){
                        for(let j =0;j<this.defaultCheckedKeys.length;j++){
                            if(this.defaultCheckedKeys[j] == data[i].categoryId){
                                this.$set(data[i],'disabled',true)
                            }
                        }
                        if(!data[i].disabled) {
                            this.$set(data[i],'disabled',false)
                        }

                        if(data[i].children && data[i].children.length){
                            this.formatLeftData(data[i].children)
                        }
                    }
                }
            }
        }

    }
</script>

<style scoped>

</style>
